import TopicTeaser from './TopicTeaser'

import {
  TEASER_CLASS,
  TEASERS_NO_RESULT_ELEMENT_CLASS,
  TEASER_NO_RESULT_ACTIVE_CLASS,
} from '../../constants/topic-list'

class TopicTeasers {
  constructor(el) {
    if (!el) return

    this.topicTeasersEl = el
    this.teasers = this.initTeasers()

    this.emptyTeasersEl = this.topicTeasersEl.querySelector(`.${TEASERS_NO_RESULT_ELEMENT_CLASS}`)
  }

  initTeasers() {
    return Array.from(this.topicTeasersEl.querySelectorAll(`.${TEASER_CLASS}`)).map(
      teaser => new TopicTeaser(teaser)
    )
  }

  showAll() {
    this.teasers.map(teaser => teaser.show())
  }

  filterByLetter(letter) {
    return this.teasers.filter(teaser => teaser.retrieveFirstLetterOfTitle() === letter)
  }

  filterListUIByLetter(letter) {
    this.showAll()
    this.teasers
      .filter(teaser => teaser.retrieveFirstLetterOfTitle() !== letter)
      .map(teaser => teaser.hide())
  }

  toggleEmptyTeasersUI(selectedLetter) {
    if (selectedLetter) {
      this.filterByLetter(selectedLetter).length
        ? this.hideEmptyTeasersUI()
        : this.showEmptyTeasersUI()
    } else {
      this.teasers.length ? this.hideEmptyTeasersUI() : this.showEmptyTeasersUI()
    }
  }

  showEmptyTeasersUI() {
    this.emptyTeasersEl.classList.add(TEASER_NO_RESULT_ACTIVE_CLASS)
  }

  hideEmptyTeasersUI() {
    this.emptyTeasersEl.classList.remove(TEASER_NO_RESULT_ACTIVE_CLASS)
  }

  _isEmpty() {
    return !!this.teasers.length
  }
}

export default TopicTeasers
